import { Link } from 'react-router-dom';
import { Tooltip, Typography, useTranslate } from '@prenuvo/halo';

import { Logo } from '@/assets/icons';
import { CONFIG } from '@/core/config';

export function HeaderLogo() {
  const translate = useTranslate();

  return (
    <div className="flex items-center">
      <Tooltip
        content={<Typography translationKey="FCT.REPORTING.HEADER.ACTIONS.RETURN_TO_DASHBOARD" />}
        side="bottom"
      >
        <Link
          aria-label={translate('FCT.REPORTING.HEADER.ACTIONS.RETURN_TO_DASHBOARD')}
          to={`${CONFIG.APPS_BASE_URL}/radiologist/dashboard/`}
        >
          <img alt="Prenuvo Logo" data-testid="header-icon" src={Logo} />
        </Link>
      </Tooltip>
    </div>
  );
}
